/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskUSAddress
 */
export interface ExecRiskUSAddress {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskUSAddress
     */
    AddressLine1Txt?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskUSAddress
     */
    AddressLine2Txt?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskUSAddress
     */
    CityNm?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskUSAddress
     */
    StateAbbreviationCd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskUSAddress
     */
    ZIPCd?: string;
}

/**
 * Check if a given object implements the ExecRiskUSAddress interface.
 */
export function instanceOfExecRiskUSAddress(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskUSAddressFromJSON(json: any): ExecRiskUSAddress {
    return ExecRiskUSAddressFromJSONTyped(json, false);
}

export function ExecRiskUSAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskUSAddress {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'AddressLine1Txt': !exists(json, 'AddressLine1Txt') ? undefined : json['AddressLine1Txt'],
        'AddressLine2Txt': !exists(json, 'AddressLine2Txt') ? undefined : json['AddressLine2Txt'],
        'CityNm': !exists(json, 'CityNm') ? undefined : json['CityNm'],
        'StateAbbreviationCd': !exists(json, 'StateAbbreviationCd') ? undefined : json['StateAbbreviationCd'],
        'ZIPCd': !exists(json, 'ZIPCd') ? undefined : json['ZIPCd'],
    };
}

export function ExecRiskUSAddressToJSON(value?: ExecRiskUSAddress | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'AddressLine1Txt': value.AddressLine1Txt,
        'AddressLine2Txt': value.AddressLine2Txt,
        'CityNm': value.CityNm,
        'StateAbbreviationCd': value.StateAbbreviationCd,
        'ZIPCd': value.ZIPCd,
    };
}

